import { useContext } from 'react'
import { ModalContext } from '../context'

import type { UseModalContextType } from '../types'

export const useModalContext = (): UseModalContextType =>
  useContext(ModalContext)
